export default "__VITE_ASSET__LC3Yga0f__"